import { render, staticRenderFns } from "./SearchResultsContent.vue?vue&type=template&id=31261cc0&scoped=true&"
import script from "./SearchResultsContent.vue?vue&type=script&lang=js&"
export * from "./SearchResultsContent.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsContent.vue?vue&type=style&index=0&id=31261cc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31261cc0",
  null
  
)

export default component.exports